import { useContext, useMemo } from "react";
import { OrganizationContext } from "../context/OrganizationContext";
import { resolveWorkSchedule } from "../helpers/tasks/workSchedule";

/**
 * The Organization Work Schedule the app should use right now.
 * { status: "configured" | "default" | "unknown", schedule, minutesPerDay }
 * Works without an OrganizationProvider (status "unknown"), so task screens
 * never crash and never invent a schedule they do not know.
 */
export function useWorkSchedule() {
  const ctx = useContext(OrganizationContext);
  const settings = ctx ? ctx.settings : undefined;
  return useMemo(() => {
    const resolved = resolveWorkSchedule(settings);
    return {
      ...resolved,
      minutesPerDay: resolved.schedule ? resolved.schedule.minutesPerDay : null,
    };
  }, [settings]);
}

export default useWorkSchedule;
